import { Components, Theme } from '@mui/material';

const MuiAccordionDetails: Components<Theme>['MuiAccordionDetails'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(theme.spacingSizes.sm, 0, 0, 0),
    })
  },
};

export default MuiAccordionDetails;
